/**
 * @generated SignedSource<<166b18ef5987b5cd1673b99bf5e67457>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingWizardUIFooterFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WizardFooter_Node">;
  readonly " $fragmentType": "BookingWizardUIFooterFragment";
};
export type BookingWizardUIFooterFragment$key = {
  readonly " $data"?: BookingWizardUIFooterFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingWizardUIFooterFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingWizardUIFooterFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WizardFooter_Node"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "1b737534ecb4f826c2007aebb95f1972";

export default node;
